import fetch from './fetch';

import { ENV } from '../settings/env';
import { FAVORITE_CDC_URLS } from '../settings/favorite';

export function getFavorite() {
  return fetch(FAVORITE_CDC_URLS[ENV], {}, 'cdc')
    .then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/services/favorite.js